import React from 'react';
import cn from 'classnames';
import {NavLink} from 'react-router-dom';

import styles from './Tabs.module.sass';

type PathType = string | {pathname: string; search?: string; hash?: string; state?: any};

export enum TabTypes {
  button = 'button',
  link = 'link',
}
export type TabsItem = {
  label: string;
  idx?: number;
  path?: PathType;
  type?: TabTypes;
};

export type TabsProps = {
  items: TabsItem[];
  currentItemActive?: number;
  className?: string;
  children?: React.ReactNode;
  nonInteractive?: boolean;
  onClick?: (e: any, pathname: string, index?: number) => void;
};

function Tabs({
  items,
  className,
  children,
  nonInteractive,
  currentItemActive = 0,
  onClick = () => {},
}: TabsProps) {
  return (
    <div
      className={cn(styles.tabsWrapper, className, {
        [styles.nonInteractive]: nonInteractive,
      })}
    >
      <div className={cn(styles.tabsLinks, 'tabs_tabs-links')}>
        {items.map(({label, path = '', type = TabTypes.link, idx}, key) => {
          const pathName = typeof path === 'string' ? path : path?.pathname;

          if (type === TabTypes.button) {
            const isActive = currentItemActive === idx;
            return (
              <button
                key={key}
                className={cn(styles.tabsButton, 'tabs_tabs-button', {
                  [styles.active]: isActive,
                })}
                onClick={e => onClick(e, pathName, idx)}
              >
                {label}
              </button>
            );
          }
          return (
            <NavLink
              key={key}
              className={cn(styles.tabsLink, 'tabs_tabs-link')}
              activeClassName={styles.active}
              to={path}
              onClick={e => onClick(e, pathName)}
            >
              {label}
            </NavLink>
          );
        })}
      </div>
      <div className={styles.tabsContent}>{children}</div>
    </div>
  );
}

export {Tabs};
